
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAircraftHelicopter as ObiAircraftHelicopterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-aircraft-helicopter.js';
 
 
 

 
 export const ObiAircraftHelicopter = createComponent({
   react: React,
   tagName: 'obi-aircraft-helicopter',
   elementClass: ObiAircraftHelicopterElement,
   events: {
     
   }
  });
 
 